"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.youtubeCategoryLabel = exports.DEFAULT_YOUTUBE_CATEGORY_ID = exports.YOUTUBE_CATEGORIES = void 0;
/** Common YouTube video category IDs (videos.insert snippet.categoryId). */
exports.YOUTUBE_CATEGORIES = [
    { id: "22", label: "People & Blogs" },
    { id: "24", label: "Entertainment" },
    { id: "25", label: "News & Politics" },
    { id: "26", label: "Howto & Style" },
    { id: "27", label: "Education" },
    { id: "28", label: "Science & Technology" },
    { id: "17", label: "Sports" },
    { id: "19", label: "Travel & Events" },
    { id: "20", label: "Gaming" },
    { id: "23", label: "Comedy" },
];
exports.DEFAULT_YOUTUBE_CATEGORY_ID = "22";
const youtubeCategoryLabel = (categoryId) => {
    var _a;
    const match = exports.YOUTUBE_CATEGORIES.find((c) => c.id === categoryId);
    return (_a = match === null || match === void 0 ? void 0 : match.label) !== null && _a !== void 0 ? _a : categoryId;
};
exports.youtubeCategoryLabel = youtubeCategoryLabel;
